import React, { lazy } from 'react'
import MainContent from './MainContent'
import Sidebar from './Sidebar'
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import Header from "./Header"
import BreadcrumbsHeader from "./BreadcrumbsHeader"
import Loadable from 'common-components/Loadable'
import PermissionsHandler from 'views/PermissionHandler'
import Cookies from 'js-cookie'
import { FetchProfileDetails, SendBlogLink } from 'api/profile'
import { useDispatch } from 'react-redux'
import { RESET_STATE, SET_INVESTOR_DETAILS, SET_INVESTOR_TYPES } from 'store/actions'
import { FetchAllInvestorTypes, FetchAllUTMCampaignList } from 'api/utils'
import { checkForAuthorization, checkForDomain } from 'utils/index'
import { useToast } from 'context/ToastContext'
// const Sidebar =Loadable(lazy(() => import('./Sidebar')))

const MainLayout = () => {
    const { addToast } = useToast();
    const [investor_id, setInvestorID] = React.useState(Cookies.get('X-INV-ID') || null)
    const [searchParams, setSearchParams] = useSearchParams();
    const currentBackground = document.getElementsByTagName("body");
    currentBackground[0].style.backgroundColor = "#000000";
    currentBackground[0].style.height = "100dvh";
    const dispatch = useDispatch();
    const currentIP = window.location.host;
    const { data: userData, isLoading: isLoadingUserData, isRefetching } = FetchProfileDetails({ investor_id });
    const { data: investor_types_data, isLoading: isLoadingInvestorTypesData } = FetchAllInvestorTypes({ investor_id });
    const { data: utm_campaign_list, isLoading: isLoadingAllUTMCampaignList } = FetchAllUTMCampaignList();
    const {
        mutateAsync: sendBlogLink,
        status: AddStartupStatus,
        error: AddStartupError,
        isLoading: isUpdating,
        data: AddStartupResponse,
    } = SendBlogLink();

    React.useEffect(() => {
        if (userData?.data && !isLoadingUserData && !isRefetching) dispatch({ type: SET_INVESTOR_DETAILS, data: userData?.data });
    }, [userData?.data, isLoadingUserData])

    React.useEffect(() => {
        if (!isLoadingInvestorTypesData && investor_types_data) {
            dispatch({ type: SET_INVESTOR_TYPES, investor_types: investor_types_data });
        }
    }, [investor_types_data, isLoadingInvestorTypesData])

    const navigate = useNavigate();
    if (!Cookies.get("X-INV-ID")) {
        const handleLogOut = () => {
            // dispatch({ type: SET_MENU, opened: false });
            dispatch({ type: RESET_STATE });
            Cookies.remove('X-INV-JWT', { path: '/' });
            Cookies.remove('X-INV-JWT', { domain: checkForDomain() });
            Cookies.remove('X-INV-ID', { path: '/' });
            Cookies.remove('X-INV-ID', { domain: checkForDomain() });
            Cookies.remove('name', { path: '/' });
            Cookies.remove('user_id', { path: '/' });
            Cookies.remove('startup_id', { path: '/' });
            Cookies.remove('email', { path: '/' });
            Cookies.remove('is_profile_complete', { path: '/' });
            Cookies.remove('startup_id', { path: '/' });
            Cookies.remove('step', { path: '/' });
            Cookies.remove('permissions', { path: '/' });
            Cookies.remove('ur', { path: '/' });
            Cookies.remove('search_startups', { path: '/' });
            Cookies.remove('search_backrr_startups', { path: '/' });
            Cookies.remove('backrr_startups_query', { path: '/' });
            Cookies.remove('backrr_startups_status', { path: '/' });
            const cookies = document.cookie.split(";");
            cookies.forEach(cookie => {
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            });
            navigate('/login');
        };
        handleLogOut();
    }

    const utm_campaign = searchParams.get("utm_campaign")

    React.useEffect(() => {
        if (
            !isLoadingAllUTMCampaignList &&
            investor_id &&
            checkForAuthorization() &&
            utm_campaign && utm_campaign_list && userData?.data?.email
        ) {
            if (Object.prototype.hasOwnProperty.call(utm_campaign_list, utm_campaign)) {
                const payload = {
                    utm_campaign,
                    investor: {
                        email: userData?.data?.email,
                        first_name: "Investor",
                        investor_id
                    }
                }
                sendBlogLink(payload).then((response) => {
                    if (response?.data?.statusCode === 200) {
                        if (response?.data?.success) {
                            addToast("The blog link has been sent via email", "success");
                            navigate("/", { replace: true });
                        } else {
                            navigate("/", { replace: true });
                        }
                        // else {
                        //     addToast("The blog link has already been sent via email", "success");
                        //     navigate("/", { replace: true });
                        // }
                    }
                    else {
                        addToast(response?.data?.message, "error")
                    }
                }).catch(err => {
                    addToast(err?.response?.data?.message, "error")
                });
            } else {
                addToast("Invalid Campaign", "error");
            }
        }
    }, [isLoadingAllUTMCampaignList, utm_campaign, utm_campaign_list, userData?.data?.email]);
    // console.log(currentBackground[0].style.backgroundColor === "#3538CD","currentBackground")
    return (
        <div style={{ display: 'flex' }}>
            <PermissionsHandler investor_id={investor_id} investor_types_data={investor_types_data} />
            <Sidebar />
            <div style={{ flexGrow: 1 }}>
                {/* <Header /> */}
                <MainContent>
                    {/* <BreadcrumbsHeader /> */}
                    <Outlet />
                </MainContent>
            </div>
        </div>
    )
}

export default MainLayout